exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.rated[data-v-43b7cb80] {\n  color: #f59f01;\n}\n.btn-customer-rating[data-v-43b7cb80] {\n  min-width: 30px;\n  background-color: #80808087;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-43b7cb80","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/jobs/JobCustomerInfo.vue
// module id = PYav
// module chunks = 0